import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { WorkExperience } from './work-experience.model';
import * as WorkExperienceActions from './work-experience.actions';

export const workExperiencesFeatureKey = 'workExperiences';

export interface State extends EntityState<WorkExperience> {
  // additional entities state properties
}

export const adapter: EntityAdapter<WorkExperience> = createEntityAdapter<WorkExperience>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});


export const reducer = createReducer(
  initialState,
  on(WorkExperienceActions.addWorkExperience,
    (state, action) => adapter.addOne(action.workExperience, state)
  ),
  on(WorkExperienceActions.upsertWorkExperience,
    (state, action) => adapter.upsertOne(action.workExperience, state)
  ),
  on(WorkExperienceActions.addWorkExperiences,
    (state, action) => adapter.addMany(action.workExperiences, state)
  ),
  on(WorkExperienceActions.upsertWorkExperiences,
    (state, action) => adapter.upsertMany(action.workExperiences, state)
  ),
  on(WorkExperienceActions.updateWorkExperience,
    (state, action) => adapter.updateOne(action.workExperience, state)
  ),
  on(WorkExperienceActions.updateWorkExperiences,
    (state, action) => adapter.updateMany(action.workExperiences, state)
  ),
  on(WorkExperienceActions.deleteWorkExperience,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(WorkExperienceActions.deleteWorkExperiences,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(WorkExperienceActions.loadWorkExperiences,
    (state, action) => adapter.setAll(action.workExperiences, state)
  ),
  on(WorkExperienceActions.clearWorkExperiences,
    state => adapter.removeAll(state)
  ),
);


export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
